module.exports = __webpack_public_path__ + "img/qris_new.7b722d13.png";